export const API_PATHS = {
  auth: {
    signupEmailCode: '/Org/Public/Signup/EmailCode/',
    login: '/Org/Auth/Login/',
    findLoginWorkspaces: '/Org/Auth/ResolveLoginOrganizations/',
    signup: '/Org/Auth/Signup/',
    clubCompanySignup: '/org/create/club-company/',
    logout: '/Org/Auth/Logout/',
    getByToken: '/Org/Auth/GetByToken/',
    forgotPassword: '/Org/Auth/ForgotPassword/',
    resendVerificationEmail: '/Org/Auth/ResendVerificationEmail/',
    verifyPhoneOtp: '/Org/Auth/ForgotPassword/VerifyOTP/',
    verifyEmailOtp: '/Org/Auth/ForgotPassword/VerifyViaEmail/',
    resetPassword: '/Org/Auth/ResetPassword/',
    changePassword: '/Org/Auth/ChangePassword/',
  },
  security: {
    companySignup: '/Security/Auth/CompanySignup/',
  },
  social: {
    communitySignup: '/Social/Auth/CommunitySignup/',
    communitySignupMeta: '/Social/Auth/CommunitySignup/Meta/',
    adminDashboard: '/Social/Admin/Dashboard/',
    helpRequests: '/Social/Help/Requests/',
    helpRequestAction: (id: string | number) => `/Social/Help/Requests/${id}/Action/`,
  },
  profile: {
    get: '/Org/User/Profile/Get/',
    update: '/Org/User/Profile/Update/',
  },
  userDocuments: {
    catalogList: '/Org/User/Documents/Catalog/List/',
    sectionList: '/Org/User/DocumentSection/List/',
    sectionCreate: '/Org/User/DocumentSection/Add/',
    sectionGet: (id: string | number) => `/Org/User/DocumentSection/Get/${id}/`,
    sectionUpdate: (id: string | number) => `/Org/User/DocumentSection/Update/${id}/`,
    sectionRemove: (id: string | number) => `/Org/User/DocumentSection/Remove/${id}/`,
    list: '/Org/User/Documents/List/',
    add: '/Org/User/Documents/Add/',
    update: (id: string | number) => `/Org/User/Document/Update/${id}/`,
    approve: (id: string | number) => `/Org/User/Document/Approve/${id}/`,
    reject: (id: string | number) => `/Org/User/Document/Reject/${id}/`,
    removeFront: (id: string | number) => `/Org/User/Document/Front/Remove/${id}/`,
    removeBack: (id: string | number) => `/Org/User/Document/Back/Remove/${id}/`,
    remove: (id: string | number) => `/Org/User/Documents/Remove/${id}/`,
  },
  serviceInstances: {
    list: '/Org/Services/ServiceInstances/ListWithNode/',
  },
  billing: {
    status: '/Org/Billing/Status/',
    cardSetup: '/Org/Billing/CardSetup/',
    cardConfirm: '/Org/Billing/CardConfirm/',
    switchToAnnual: '/Org/Billing/SwitchToAnnual/',
  },
  helpSupport: {
    list: '/Org/HelpSupport/List/',
    add: '/Org/HelpSupport/Add/',
    update: (id: string | number) => `/Org/HelpSupport/Update/${id}/`,
    reply: (id: string | number) => `/Org/HelpSupport/Reply/${id}/`,
  },
  masterAdmin: {
    overview: '/Org/MasterAdmin/Overview/',
    supportList: '/Org/MasterAdmin/Support/List/',
    supportUpdate: (id: string | number) => `/Org/MasterAdmin/Support/Update/${id}/`,
    supportReply: (id: string | number) => `/Org/MasterAdmin/Support/Reply/${id}/`,
    supportNote: (id: string | number) => `/Org/MasterAdmin/Support/Note/${id}/`,
    parentOrgAction: (id: string | number, action: 'Suspend' | 'Reactivate') => `/Org/MasterAdmin/ParentOrgs/${id}/${action}/`,
    supportAssign: (id: string | number) => `/Org/MasterAdmin/Support/Assign/${id}/`,
    invoices: '/Org/MasterAdmin/Invoices/',
    billing: '/Org/MasterAdmin/Billing/',
    integrationCosts: '/Org/MasterAdmin/IntegrationCosts/',
    facilityProPricing: '/Org/Public/Pricing/FacilityPro/',
    systemHealth: '/Org/MasterAdmin/SystemHealth/',
    auditLog: '/Org/MasterAdmin/AuditLog/',
    settings: '/Org/MasterAdmin/Settings/',
    settingsUpdate: '/Org/MasterAdmin/Settings/Update/',
    orgAction: (id: string | number, action: 'Suspend' | 'Reactivate' | 'Terminate' | 'SupportAccess' | 'SupportRoles' | 'ExtendTrial') =>
      `/Org/MasterAdmin/Organizations/${id}/${action}/`,
    me: '/Org/MasterAdmin/Me/',
    pricingDocument: '/Org/MasterAdmin/Pricing/',
    pricingUpdate: '/Org/MasterAdmin/Pricing/Update/',
    staff: '/Org/MasterAdmin/Staff/',
    staffInvite: '/Org/MasterAdmin/Staff/Invite/',
    staffAction: (postId: string | number, action: 'Role' | 'Remove' | 'ResendInvite') =>
      `/Org/MasterAdmin/Staff/${postId}/${action}/`,
  },
  organisation: {
    branches: {
      list: '/Org/Branch/List/',
      siblingsList: '/Org/Branch/Instances/List',
      create: '/Org/Branch/Add/',
      updateAdmin: (id: string | number) => `/Org/Branch/Admin/Update/${id}/`,
      supportAdmin: (id: string | number) => `/Org/Branch/Admin/Support/${id}/`,
      remove: (id: string | number) => `/Org/Branch/Remove/${id}/`,
      suspend: (id: string | number) => `/Org/Branch/Suspend/${id}/`,
      activate: (id: string | number) => `/Org/Branch/Activate/${id}/`,
    },
    tenants: {
      list: '/Org/Tenant/List/',
      archive: (id: string | number) => `/Org/Tenant/Archive/${id}/`,
      restore: (id: string | number) => `/Org/Tenant/Restore/${id}/`,
      updateSuperAdmin: (id: string | number) => `/Org/Tenant/SuperAdmin/Update/${id}/`,
      bootstrapSuperAdmin: (id: string | number) => `/Org/Tenant/SuperAdmin/Bootstrap/${id}/`,
      supportSuperAdmin: (id: string | number) => `/Org/Tenant/SuperAdmin/Support/${id}/`,
    },
    verticals: {
      list: '/Org/Firm/Vertical/List/',
      create: '/Org/Firm/Vertical/Add/',
      detail: (id: string | number) => `/Org/Firm/Vertical/Get/${id}/`,
      update: (id: string | number) => `/Org/Firm/Vertical/Update/${id}/`,
      remove: (id: string | number) => `/Org/Firm/Vertical/Remove/${id}/`,
    },
    levelVariants: {
      list: '/Org/Firm/Vertical/ManageVariants/List/',
      create: '/Org/Firm/Vertical/ManageVariants/Add/',
      detail: (id: string | number) => `/Org/Firm/Vertical/ManageVariants/Get/${id}/`,
      update: (id: string | number) => `/Org/Firm/Vertical/ManageVariants/Update/${id}/`,
      remove: (id: string | number) => `/Org/Firm/Vertical/ManageVariants/Remove/${id}/`,
    },
  },
  portalNotifications: {
    list: '/Org/Portal/Notifications/List/',
  },
  notifications: {
    registerFcmToken: '/api/notifications/fcm-token/',
  },
  aiAssist: {
    parseCreate: '/ai/assist/parse-create/',
    confirmCreate: '/ai/assist/confirm-create/',
  },
  marketing: {
    announcements: {
      list: '/marketing/announcements/',
      publicList: '/marketing/announcements/public/',
      permissions: '/marketing/announcements/permissions/',
      sendNow: (id: string | number) => `/marketing/announcements/${id}/send_now/`,
      sendPush: (id: string | number) => `/marketing/announcements/${id}/send_push/`,
      appManagers: '/marketing/announcements/app_managers/',
    },
  },
  meta: {
    oauthStart: '/Store/Meta/OAuth/Start/',
    oauthCallback: '/Store/Meta/OAuth/Callback/',
    connectionGet: '/Store/Meta/Connection/Get/',
    connectionSelectAssets: '/Store/Meta/Connection/SelectAssets/',
    connectionDisconnect: '/Store/Meta/Connection/Disconnect/',
    catalogPreview: '/Store/Meta/Catalog/Preview/',
    catalogCreate: '/Store/Meta/Catalog/Create/',
    catalogSync: '/Store/Meta/Catalog/Sync/',
    catalogItemSync: '/Store/Meta/Catalog/Item/Sync/',
    catalogItemRemove: '/Store/Meta/Catalog/Item/Remove/',
    syncRunsList: '/Store/Meta/Catalog/SyncRuns/List/',
    catalogItemsList: '/Store/Meta/Catalog/Items/List/',
    webhookEventsList: '/Store/Meta/Orders/Events/List/',
    messageSend: '/Store/Meta/Messages/Send/',
  },
  orgTree: {
    nodes: {
      list: '/Org/Tree/Node/List',
      add: '/Org/Tree/Node/Add',
      update: (id: string | number) => `/Org/Tree/Node/Update/${id}`,
      delete: (id: string | number) => `/Org/Tree/Node/Remove/${id}`,
      branchAdd: '/Org/Tree/Branch/Add',
    },
    nodeApps: {
      add: '/Org/Tree/Node/App/Add/',
    },
    config: {
      get: (id: string | number) => `/Org/Tree/NodeConfig/Get/${id}/`,
      update: (id: string | number) => `/Org/Tree/NodeConfig/Update/${id}/`,
    },
    address: {
      list: '/Org/Tree/NodeAddress/List/',
      create: (id: string | number) => `/Org/Tree/NodeAddress/Create/${id}`,
      update: (id: string | number) => `/Org/Tree/NodeAddress/Update/${id}`,
      delete: (id: string | number) => `/Org/Tree/NodeAddress/Remove/${id}/`,
         status: (id: string | number) => `/Org/Tree/NodeAddress/Status/${id}`,
    },
    settings: {
      social: '/Org/Tree/NodeSetting/SocialMedias/List',
      contacts: '/Org/Tree/NodeSetting/SocialMedias/Contact/List',
      add: '/Org/Tree/NodeSetting/Add',
      addSocial: '/Org/Tree/Node/SocialMedia/Add',
      addContact: '/Org/Tree/Node/Contact/Add',
      edit: (id: string | number) => `/Org/Tree/NodeSetting/Edit/${id}/`,
      update: '/Org/Tree/NodeSetting/Update',
      delete: (id: string | number) => `/Org/Tree/NodeSetting/Remove/${id}/`,
    },
    serviceAreas: {
      list: '/Org/Tree/NodeServiceArea/List/',
      create: '/Org/Tree/NodeServiceArea/Add/',
      detail: (id: string | number) => `/Org/Tree/NodeServiceArea/Get/${id}/`,
      update: (id: string | number) => `/Org/Tree/NodeServiceArea/Update/${id}/`,
      delete: (id: string | number) => `/Org/Tree/NodeServiceArea/Remove/${id}/`,
    },
    businessDays: {
      list: '/Org/Services/BusinessDays/List/',
      create: '/Org/Services/BusinessDays/Add/',
      detail: (id: string | number) => `/Org/Services/BusinessDay/Get/${id}/`,
      update: (id: string | number) => `/Org/Services/BusinessDay/Update/${id}/`,
      delete: (id: string | number) => `/Org/Services/BusinessDay/Remove/${id}/`,
    },
    businessHours: {
      list: '/Org/Services/BusinessHours/List/',
      create: '/Org/Services/BusinessHours/Add/',
      detail: (id: string | number) => `/Org/Services/BusinessHours/Get/${id}/`,
      update: (id: string | number) => `/Org/Services/BusinessHours/Update/${id}/`,
      delete: (id: string | number) => `/Org/Services/BusinessHours/Remove/${id}/`,
    },
    instanceVariants: {
      add: '/Org/InstanceVariantMap/Add',
      update: '/Org/InstanceVariantMap/Update/',
      list: '/Org/InstanceVariantMap/List',
      publicList: '/Org/Public/Instance/Services/List',
    },
    serviceVariants: {
      list: '/Org/ServiceVariant/List',
      outboundList: '/Org/Services/Variants/List/',
    },
    serviceInstances: {
      /** Paginated org tree list; supports `node_id`, `lvl_variant`, `unique_level_variant_id` (legacy), `page_size`, etc. */
      list: '/Org/Services/ServiceInstances/List/',
      listWithNode: '/Org/Services/ServiceInstances/ListWithNode/',
      add: '/Org/Services/ServiceInstances/Add/',
      createClient: '/Org/Tree/Client/Add',
      getPublic: (orgInstanceId: string | number) => `/Org/Services/ServiceInstances/Get/${encodeURIComponent(String(orgInstanceId))}/`,
      get: (id: string | number) => `/Org/ServiceInstances/Get/${id}/`,
      ancestorRoot: (id: string | number) => `/Org/ServiceInstances/AncestorRoot/Get/${id}/`,
      getByIdentifier: (identifier: string) => `/Org/Services/ServiceInstancesByIdentifier/Get/${encodeURIComponent(identifier)}/`,
      resolveTenantTheme: '/Org/Public/TenantTheme/Resolve/',
      credentialsGet: (id: string | number) => `/Org/ServiceInstances/Credentials/Get/${id}/`,
      credentialsUpdate: (id: string | number) => `/Org/Services/ServiceInstances/Credentials/Update/${id}/`,
      appSettingsGet: (id: string | number) => `/Org/ServiceInstances/AppSettings/Get/${id}/`,
      appSettingsUpdate: (id: string | number) => `/Org/Services/ServiceInstances/AppSettings/Update/${id}/`,
      credentialsTest: (id: string | number) => `/Org/Services/ServiceInstances/Credentials/Test/${id}/`,
      templatePreview: (id: string | number) => `/Org/Services/ServiceInstances/Templates/Preview/${id}/`,
      locationSearch: (id: string | number) => `/Org/Services/ServiceInstances/Location/Search/${id}/`,
      mapsClientConfigGet: (id: string | number) => `/Org/Services/ServiceInstances/Maps/ClientConfig/Get/${id}/`,
      mediaList: (id: string | number) => `/Org/Services/ServiceInstances/Media/List/${id}/`,
      mediaUpload: (id: string | number) => `/Org/Services/ServiceInstances/Media/Add/${id}/`,
      mediaDelete: (id: string | number, mediaId: string | number) => `/Org/Services/ServiceInstances/Media/Remove/${id}/${mediaId}/`,
      adminUpdate: (id: string | number) => `/Org/ServiceInstance/Admin/Update/${id}/`,
      update: (id: string | number) => `/Org/Services/ServiceInstances/Update/${id}/`,
      delete: (id: string | number) => `/Org/Services/ServiceInstances/Remove/${id}/`,
    },
    meta: {
      countries: '/country/?page_size=1000',
      states: (countryId: string | number) => `/state/?page_size=1000&country-id=${countryId}`,
      counties: (countryId: string | number) => `/county/?country-id=${countryId}`,
      cities: (countryId: string | number, stateId: string | number) => `/city/?page_size=1000&country-id=${countryId}&state-id=${stateId}`,
      currencies: '/currency/',
      timezones: '/timezone/',
      socialMediaTypes: '/Org/Contacts/SocialMedia/List/',
      contactTypes: '/Org/Contacts/ContactTypes/List/',
    },
  },
  orgWallet: {
    wallets: {
      list: '/Org/Wallet/List/',
      create: '/Org/Wallet/Add/',
      detail: (id: string | number) => `/Org/Wallet/Get/${id}/`,
      update: (id: string | number) => `/Org/Wallet/Update/${id}/`,
      delete: (id: string | number) => `/Org/Wallet/Remove/${id}/`,
      paymentGateways: '/Org/Wallet/List/Org/Payment/Gateway/',
    },
    variants: {
      list: '/Org/WalletVariant/List/',
    },
  },
  orgUsers: {
    list: '/Org/User/List/',
    detail: '/Org/User/GetUserDetail/',
    groups: '/Org/Usergroup/List/',
    groupsPublic: '/Org/Public/Usergroup/List/',
    groupCreate: '/Org/Usergroup/Add/',
    groupGet: (id: string | number) => `/Org/Usergroup/Get/${id}/`,
    groupUpdate: (id: string | number) => `/Org/Usergroup/Update/${id}/`,
    groupDelete: (id: string | number) => `/Org/Usergroup/Remove/${id}/`,
    groupGrant: '/Org/Usergroup/Grant/',
    suppliers: '/Supplier/List/',
    supplierDetail: (id: string) => `/Supplier/Get/${id}/`,
    createSupplier: '/Supplier/Add/',
    updateSupplier: (id: string) => `/Supplier/Update/${id}/`,
    deleteSupplier: (id: string) => `/Supplier/Delete/${id}/`,
    supplierGroups: '/Supplier/Groups/',
    clients: '/Client/List/',
    clientDetail: (id: string) => `/Client/Get/${id}/`,
    createClient: '/Client/Add/',
    updateClient: (id: string) => `/Client/Update/${id}/`,
    deleteClient: (id: string) => `/Client/Delete/${id}/`,
    clientGroups: '/Client/Groups/',
  },
  orgUserAdmin: {
    create: '/Org/User/Admin/Create/',
    signupConfig: '/Org/User/Admin/SignupConfig/',
    // Deprecated for list operations: use /Org/User/List/ via orgUserAdminApi.list consolidation.
    list: '/Org/User/Admin/List/',
    detail: (id: string | number) => `/Org/User/Admin/Get/${id}/`,
    update: (id: string | number) => `/Org/User/Admin/Update/${id}/`,
    unlock: (id: string | number) => `/Org/User/Admin/Unlock/${id}/`,
    resetPin: (id: string | number) => `/Org/User/Admin/ResetPin/${id}/`,
    forcePasswordReset: (id: string | number) => `/Org/User/Admin/ForcePasswordReset/${id}/`,
    suspend: (id: string | number) => `/Org/User/Admin/Suspend/${id}/`,
    activate: (id: string | number) => `/Org/User/Admin/Activate/${id}/`,
    associateBranch: (id: string | number) => `/Org/User/Admin/AssociateBranch/${id}/`,
    approveBranchAssociation: (id: string | number) => `/Org/User/Admin/ApproveBranchAssociation/${id}/`,
    rejectBranchAssociation: (id: string | number) => `/Org/User/Admin/RejectBranchAssociation/${id}/`,
    detachBranchAssociation: (id: string | number) => `/Org/User/Admin/DetachBranchAssociation/${id}/`,
    updateBranchAccessStatus: (id: string | number) => `/Org/User/Admin/BranchAccessStatus/Update/${id}/`,
    updateRegistrationStatus: (id: string | number) => `/Org/User/Admin/RegistrationStatus/Update/${id}/`,
    remove: (id: string | number) => `/Org/User/Admin/Remove/${id}/`,
    assignmentAdd: '/Org/User/Admin/Assignments/Add/',
    assignmentRemove: (id: string | number) => `/Org/User/Admin/Assignments/Remove/${id}/`,
  },
  orgRoles: {
    // Canonical role-list endpoint for role pickers and assignment flows.
    list: '/Org/Roles/List/',
    create: '/Org/Roles/Add/',
    get: (id: string | number) => `/Org/Roles/Get/${id}/`,
    update: (id: string | number) => `/Org/Roles/Update/${id}/`,
    delete: (id: string | number) => `/Org/Roles/Remove/${id}/`,
    activate: (id: string | number) => `/Org/Roles/Activate/${id}/`,
    deactivate: (id: string | number) => `/Org/Roles/Deactivate/${id}/`,
    groupsList: '/Org/Roles/Group/List/',
    groupsCreate: '/Org/Roles/Group/Add/',
    groupsUpdate: (id: string | number) => `/Org/Roles/Group/Update/${id}/`,
    groupsDelete: (id: string | number) => `/Org/Roles/Group/Remove/${id}/`,
  },
  catalogRoles: {
    list: '/Org/Catalog-Roles/List/',
    create: '/Org/Catalog-Roles/Add/',
    get: (id: string | number) => `/Org/Catalog-Roles/Get/${id}/`,
    update: (id: string | number) => `/Org/Catalog-Roles/Update/${id}/`,
    delete: (id: string | number) => `/Org/Catalog-Roles/Remove/${id}/`,
    groupsList: '/Org/Catalog-Roles/Group/List/',
    groupsCreate: '/Org/Catalog-Roles/Group/Add/',
    groupsGet: (id: string | number) => `/Org/Catalog-Roles/Group/Get/${id}/`,
    groupsUpdate: (id: string | number) => `/Org/Catalog-Roles/Group/Update/${id}/`,
    groupsDelete: (id: string | number) => `/Org/Catalog-Roles/Group/Remove/${id}/`,
  },
  scopedRoles: {
    jobsList: '/Jobs/Roles/List/',
    eventList: '/Event/Roles/List/',
    committeeList: '/Committee/Roles/List/',
    taskList: '/Task/Roles/List/',
  },
  policy: {
    features: {
      create: '/Org/Policy/Feature/Add/',
      retrieve: (id: string | number) => `/Org/Policy/Feature/Get/${id}/`,
      list: '/Org/Policy/Feature/List/',
      details: '/Org/Policy/Feature/GetDetails/',
      update: (id: string | number) => `/Org/Policy/Feature/Update/${id}`,
      delete: (id: string | number) => `/Org/Policy/Feature/Remove/${id}/`,
    },
    rolePermissions: {
      create: '/Org/Policy/RolePermission/Add/',
      reset: '/Org/Policy/RolePermission/ResetDefaults/',
      saveDefaults: '/Org/Policy/RolePermission/SaveDefaults/',
      list: '/Org/Policy/RolePermission/List/',
      update: (id: string | number) => `/Org/Policy/RolePermission/Update/${id}`,
      delete: (id: string | number) => `/Org/Policy/RolePermission/Remove/${id}/`,
    },
    userGroupPermissions: {
      create: '/Org/Policy/UserGroupPermission/Add/',
      list: '/Org/Policy/UserGroupPermission/List/',
    },
    rolePermissionNodes: {
      list: '/Org/Tenant/RoleAccess/List/',
      create: '/Org/Tenant/RoleAccess/Add/',
      delete: (id: string | number) => `/Org/Tenant/RoleAccess/Remove/${id}/`,
    },
  },
  posts: {
    list: '/Org/Posts/List/',
    userList: '/Org/Posts/UserPostList/',
    update: (id: string | number) => `/Org/Posts/Update/${id}/`,
    statusChoices: '/Org/Posts/StatusChoices/',
  },
  jobs: {
    list: '/Job/List/',
    projectsList: '/Job/Project/List/',
    eventsList: '/Job/Event/List/',
    committeesList: '/Job/Committee/List/',
    tasksList: '/Job/Task/List/',
    projectWorkOrders: (id: string) => `/Job/Project/WorkOrders/${id}/List/`,
    create: '/Job/Add/',
    createCommittee: '/Job/Committee/Add/',
    createTask: '/Job/Task/Add/',
    createProject: '/Job/Project/Add/',
    createEvent: '/Job/Event/Add/',
    financeReportsList: '/Job/FinanceReport/List/',
    financeReportsArchivedList: '/Job/FinanceReport/Archived/List/',
    financeReportCurrency: '/Job/FinanceReport/Currency/',
    createFinanceReport: '/Job/FinanceReport/Add/',
    financeReportDetail: (id: string | number) => `/Job/FinanceReport/Get/${id}/`,
    updateFinanceReport: '/Job/FinanceReport/Update/',
    archiveFinanceReport: (id: string | number) => `/Job/FinanceReport/Archive/${id}/`,
    restoreFinanceReport: (id: string | number) => `/Job/FinanceReport/Restore/${id}/`,
    financeReportPdf: (id: string | number) => `/Job/FinanceReport/Pdf/${id}/`,
    dashboard: '/Job/Dashboard/',
    detail: (id: string) => `/Job/Get/${id}/`,
    projectDetail: (id: string) => `/Job/Project/Get/${id}/`,
    eventDetail: (id: string) => `/Job/Event/Get/${id}/`,
    update: '/Job/Update/',
    updateProject: '/Job/Project/Update/',
    updateEvent: '/Job/Event/Update/',
    updateCommittee: '/Job/Committee/Update/',
    updateTask: '/Job/Task/Update/',
    mediaFieldUpload: '/Job/MediaField/Upload/',
    mediaFieldRemove: '/Job/MediaField/Remove/',
    delete: (id: string) => `/Job/Delete/${id}/`,
    lock: (id: string) => `/Job/Lock/${id}/`,
    reschedule: (id: string) => `/Job/Reschedule/${id}/`,
    unlock: (id: string) => `/Job/Unlock/${id}/`,
    status: (id: string) => `/Job/SetStatus/${id}/`,
    eventTags: {
      list: '/Job/EventTag/List/',
      create: '/Job/EventTag/Add/',
      detail: (id: string | number) => `/Job/EventTag/Get/${id}/`,
      update: (id: string | number) => `/Job/EventTag/Update/${id}/`,
      deactivate: (id: string | number) => `/Job/EventTag/Deactivate/${id}/`,
      activate: (id: string | number) => `/Job/EventTag/Activate/${id}/`,
    },
    updates: {
      list: '/Job/Updates/List/',
      create: '/Job/Updates/Add/',
      detail: (id: string | number) => `/Job/Updates/Get/${id}/`,
      update: (id: string | number) => `/Job/Updates/Update/${id}/`,
      delete: (id: string | number) => `/Job/Updates/Delete/${id}/`,
    },
    qanda: {
      list: '/Job/QandA/List/',
      create: '/Job/QandA/Add/',
      detail: (id: string | number) => `/Job/QandA/Get/${id}/`,
      update: (id: string | number) => `/Job/QandA/Update/${id}/`,
      delete: (id: string | number) => `/Job/QandA/Delete/${id}/`,
    },
    invoicePreview: (jobId: string) => `/Job/InvoicePreview/${jobId}/`,
    payrollSummary: (jobId: string) => `/Job/PayrollSummary/${jobId}/`,
    checklist: (jobId: string) => `/Job/${jobId}/Checklist/`,
    checklistProject: (jobId: string) => `/Job/Project/${jobId}/Checklist/`,
    checklistEvent: (jobId: string) => `/Job/Event/${jobId}/Checklist/`,
    checklistAdd: (jobId: string) => `/Job/${jobId}/Checklist/Add/`,
    checklistAddProject: (jobId: string) => `/Job/Project/${jobId}/Checklist/Add/`,
    checklistAddEvent: (jobId: string) => `/Job/Event/${jobId}/Checklist/Add/`,
    checklistApplyTemplate: (jobId: string) => `/Job/${jobId}/Checklist/ApplyTemplate/`,
    checklistApplyTemplateProject: (jobId: string) => `/Job/Project/${jobId}/Checklist/ApplyTemplate/`,
    checklistApplyTemplateEvent: (jobId: string) => `/Job/Event/${jobId}/Checklist/ApplyTemplate/`,
    generateNextOccurrence: (jobId: string) => `/Job/GenerateNextOccurrence/${jobId}/`,
  },
  complaints: {
    list: '/JobComplaint/List/',
    create: '/JobComplaint/Add/',
    detail: (id: string | number) => `/JobComplaint/Get/${id}/`,
    update: (id: string | number) => `/JobComplaint/Update/${id}/`,
    messages: (id: string | number) => `/JobComplaint/${id}/Messages/List/`,
    actions: (id: string | number) => `/JobComplaint/${id}/Actions/List/`,
    applyAction: (id: string | number) => `/JobComplaint/${id}/Action/`,
    messageAdd: '/JobComplaint/Message/Add/',
    messageUpload: '/JobComplaint/Message/Upload/',
    workerList: '/Job/Worker/Complaints/',
    workerCreate: '/Job/Worker/Complaints/',
    customerList: '/Job/Customer/Complaints/',
    customerCreate: '/Job/Customer/Complaints/',
  },
  jobChecklist: {
    templateList: '/JobChecklistTemplate/List/',
    templateListProject: '/JobChecklistTemplate/Project/List/',
    templateListEvent: '/JobChecklistTemplate/Event/List/',
    templateAdd: '/JobChecklistTemplate/Add/',
    templateGet: (id: string | number) => `/JobChecklistTemplate/Get/${id}/`,
    templateUpdate: (id: string | number) => `/JobChecklistTemplate/Update/${id}/`,
    templateDelete: (id: string | number) => `/JobChecklistTemplate/Delete/${id}/`,
    itemUpdate: (id: string | number) => `/JobChecklistItem/Update/${id}/`,
    itemComplete: (id: string | number) => `/JobChecklistItem/Complete/${id}/`,
    itemReopen: (id: string | number) => `/JobChecklistItem/Reopen/${id}/`,
    itemDelete: (id: string | number) => `/JobChecklistItem/Delete/${id}/`,
  },
  resourcePlanner: {
    models: '/api/resource-planner/models/',
    jobManagementInstances: '/api/resource-planner/job-management-instances/',
    modelCreate: '/api/resource-planner/planner-model/create/',
    modelUpdate: (id: string | number) => `/api/resource-planner/planner-model/${id}/update/`,
    modelDelete: (id: string | number) => `/api/resource-planner/planner-model/${id}/delete/`,
    modelConnectedCatalog: (id: string | number) => `/api/resource-planner/models/${id}/connected-catalog/`,
    resources: '/api/resource-planner/resources/',
    resourceCreate: '/api/resource-planner/planner-resource/create/',
    resourceUpdate: (id: string | number) => `/api/resource-planner/planner-resource/${id}/update/`,
    resourceDelete: (id: string | number) => `/api/resource-planner/planner-resource/${id}/delete/`,
    resourceDetail: (id: string | number) => `/api/resource-planner/resources/${id}/`,
    resourceWorkerCandidates: (id: string | number) => `/api/resource-planner/resources/${id}/worker-candidates/`,
    resourceRoleOptions: '/api/resource-planner/resources/role-options/',
    serviceResourceLinks: {
      list: '/api/resource-planner/service-resource-links/',
      create: '/api/resource-planner/service-resource-links/create/',
      delete: (id: string | number) => `/api/resource-planner/service-resource-links/${id}/delete/`,
      detail: (id: string | number) => `/api/resource-planner/service-resource-links/${id}/`,
      triggerJobsForOrder: '/api/resource-planner/service-resource-links/trigger-jobs-for-order/',
      buildContractForOrder: '/api/resource-planner/service-resource-links/build-contract-for-order/',
      plannerRunsForOrder: '/api/resource-planner/service-resource-links/planner-runs-for-order/',
    },
  },
  orders: {
    list: '/Store/Admin/Orders/List/',
    stats: '/Store/Admin/Orders/Stats/Count',
    bookingsDashboard: '/Store/Admin/Bookings/Dashboard/',
    statisticsGraph: '/Statistics/Order/statisticsgraph',
    categoryStatistics: '/Statistics/Store/category_statistics',
    detail: (referenceId: string) => `/Store/Admin/Order/GetDetails/${referenceId}/`,
    generatePaymentLink: (orderId: string | number) => `/Store/Admin/Order/PaymentLink/${orderId}/`,
    createV2: '/Store/Order/create/V2',
    payments: '/Store/Order/PaymentTransaction/List/',
    publicPaymentDetail: (orderId: string | number, paymentId: string | number) => `/OrderPayment/Public/${orderId}/${paymentId}/`,
    publicPaymentDetailByToken: (token: string) => `/OrderPayment/Public/${encodeURIComponent(token)}/`,
    createPayment: '/Store/Order/PaymentTransaction/Create/',
    removePayment: (id: string | number) => `/Store/Order/PaymentTransaction/Remove/${id}/`,
    customerCreditAccounts: '/Store/CustomerCredit/Account/List/',
    customerCreditAccountsExport: '/Store/CustomerCredit/Account/Export/',
    customerCreditSettings: '/Store/CustomerCredit/Settings/',
    customerCreditAccount: (id: string | number) => `/Store/CustomerCredit/Account/${id}/`,
    collectCustomerCredit: (id: string | number) => `/Store/CustomerCredit/Account/${id}/Collect/`,
    voidCustomerCreditRepayment: (id: string | number, repaymentId: string | number) =>
      `/Store/CustomerCredit/Account/${id}/Repayment/${repaymentId}/Void/`,
    customerCreditStatement: (id: string | number) => `/Store/CustomerCredit/Account/${id}/Statement/`,
    refunds: '/Store/Order/Refund/List/',
    createRefund: '/Store/Order/Refund/Create/',
    approveRefund: (id: string | number) => `/Store/Order/Refund/Approve/${id}/`,
    rejectRefund: (id: string | number) => `/Store/Order/Refund/Reject/${id}/`,
    removeRefund: (id: string | number) => `/Store/Order/Refund/Remove/${id}/`,
    previewRefund: '/Store/Order/Refund/Preview/',
    refundPolicies: {
      list: '/Store/Order/RefundPolicy/List/',
      create: '/Store/Order/RefundPolicy/Create/',
      update: (id: string | number) => `/Store/Order/RefundPolicy/Update/${id}/`,
      remove: (id: string | number) => `/Store/Order/RefundPolicy/Remove/${id}/`,
    },
    orderItemMediaList: '/Store/OrderItem/Media/List/',
    orderItemMediaCreate: '/Store/OrderItem/Media/Add/',
    orderItemMediaUpdate: (id: string | number) => `/Store/OrderItem/Media/Update/${id}/`,
    orderItemMediaDelete: (id: string | number) => `/Store/OrderItem/Media/Remove/${id}/`,
    resendConfirmationEmail: '/Store/Order/Confirmation/SendEmail',
    statuses: '/Store/Order/GetStatuses/',
    updateStatus: '/Store/Order/UpdateStatus/',
    updateStatusById: (id: string | number) => `/Store/Order/UpdateStatus/${id}/`,
    reviews: '/Store/Order/Review/List/',
    updateReview: (id: string | number) => `/Store/Order/Review/Update/${id}/`,
  },
  store: {
    categories: {
      list: '/Store/Product/Category/List/',
      hierarchy: '/Store/Product/GetCategoryHierarchy/',
      detail: (id: string | number) => `/Store/Product/Category/Get/${id}/`,
      create: '/Store/Product/Category/Add/',
      update: (id: string | number) => `/Store/Product/Category/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Category/Remove/${id}/`,
      deriveFromMasterV2: '/Store/Product/StoreCategory/Add/V2',
      masterList: '/Store/Product/MasterCategory/List/',
      masterDetail: (id: string | number) => `/Store/Product/MasterCategory/Get/${id}/`,
      masterCreate: '/Store/Product/MasterCategory/Add/',
      masterUpdate: (id: string | number) => `/Store/Product/MasterCategory/Update/${id}/`,
      masterDelete: (id: string | number) => `/Store/Product/MasterCategory/Remove/${id}/`,
    },
    products: {
      list: '/Store/Product/List/',
      detail: (id: string | number) => `/Store/Product/Get/${id}/`,
      create: '/Store/Product/Add/',
      update: (id: string | number) => `/Store/Product/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Remove/${id}/`,
      masterList: '/Store/Product/MasterProduct/List/',
      masterDetail: (id: string | number) => `/Store/Product/MasterProduct/Get/${id}/`,
      masterCreate: '/Store/Product/MasterProduct/Add/',
      masterUpdate: (id: string | number) => `/Store/Product/MasterProduct/Update/${id}/`,
      masterDelete: (id: string | number) => `/Store/Product/MasterProduct/Remove/${id}/`,
      removeLogo: (id: string | number) => `/Store/Product/RemoveProductLogo/${id}/`,
      importCsv: '/Store/Product/Upload/',
      exportCsv: '/Store/Product/Export/CSV',
      types: '/Store/Product/GetProductTypes/',
    },
    taxes: {
      countrySystems: '/country-tax-system/',
      countryBundles: '/country-tax-bundle/',
      countryTaxes: '/country-tax/',
      taxLabels: '/Store/Finance/Tax/Label/List/',
      createTaxLabel: '/Store/Finance/Tax/Label/Add/',
      updateTaxLabel: (id: string | number) => `/Store/Finance/Tax/Label/Update/${id}/`,
      taxLabelDetail: (id: string | number) => `/Store/Finance/Tax/Label/Get/${id}/`,
      taxes: '/Store/Finance/Tax/List/',
    },
    productFeatures: {
      list: '/Store/Product/Feature/List/',
      create: '/Store/Product/Feature/Add/',
      update: (id: string | number) => `/Store/Product/Feature/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Feature/Remove/${id}/`,
      bootstrap: '/Store/Product/Feature/Bootstrap/',
      productAssignments: (productId: string | number) =>
        `/Store/Product/Feature/Assignments/${productId}/`,
      setProductAssignments: (productId: string | number) =>
        `/Store/Product/Feature/Assignments/${productId}/Set/`,
      variantAssignments: (variantId: string | number) =>
        `/Store/Product/Variant/Feature/Assignments/${variantId}/`,
      setVariantAssignments: (variantId: string | number) =>
        `/Store/Product/Variant/Feature/Assignments/${variantId}/Set/`,
    },
    productUniqueNames: {
      list: '/Store/Product/UniqueName/List/',
      detail: (id: string | number) => `/Store/Product/UniqueName/Get/${id}/`,
      create: '/Store/Product/UniqueName/Add/',
      update: (id: string | number) => `/Store/Product/UniqueName/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/UniqueName/Remove/${id}/`,
    },
    brands: {
      list: '/Store/Product/Brand/List/',
      detail: (id: string | number) => `/Store/Product/Brand/Get/${id}/`,
      create: '/Store/Product/Brand/Add/',
      update: (id: string | number) => `/Store/Product/Brand/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Brand/Remove/${id}/`,
    },
    variants: {
      list: '/Store/Product/Variant/List/',
      detail: (id: string | number) => `/Store/Product/Variant/Get/${id}/`,
      create: '/Store/Product/Variant/Add/',
      update: (id: string | number) => `/Store/Product/Variant/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Variant/Remove/${id}/`,
      removeLogo: (id: string | number) => `/Store/Product/Variant/RemoveLogo/${id}/`,
      deactivate: '/Store/Product/Variant/Deactivate/',
      mediaList: (variantId: string | number) => `/Store/Product/Media/GetBannerByProductVariantId/${variantId}/`,
      mediaCreate: '/Store/Product/Variant/Media/Add/',
      mediaDelete: (id: string | number) => `/Store/Product/Variant/Media/Remove/${id}/`,
    },
    variantPrices: {
      detail: (variantId: string | number) => `/Store/Product/Variant/price/Get/${variantId}/`,
      create: '/Store/Product/Variant/price/Add/',
      update: (id: string | number) => `/Store/Product/Variant/price/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Variant/price/Remove/${id}/`,
    },
    variantAddonGroups: {
      list: '/Store/Product/Variant/AddonGroup/List/',
      create: '/Store/Product/Variant/AddonGroup/Add/',
      delete: (id: string | number) => `/Store/Product/Variant/AddonGroup/Remove/${id}/`,
    },
    variantAddonItems: {
      list: '/Store/Product/Variant/Addon/List/',
      create: '/Store/Product/Variant/Addon/Add/',
      delete: (id: string | number) => `/Store/Product/Variant/Addon/Remove/${id}/`,
    },
    addonGroups: {
      list: '/Store/Product/AddonGroup/List/',
      detail: (id: string | number) => `/Store/Product/AddonGroup/Get/${id}/`,
      create: '/Store/Product/AddonGroup/Add/',
      update: (id: string | number) => `/Store/Product/AddonGroup/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/AddonGroup/Remove/${id}/`,
    },
    addons: {
      list: '/Store/Product/Addon/List/',
      detail: (id: string | number) => `/Store/Product/Addon/Get/${id}/`,
      create: '/Store/Product/Addon/Add/',
      update: (id: string | number) => `/Store/Product/Addon/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Addon/Remove/${id}/`,
    },
    offers: {
      list: '/Store/Offer/List/',
      detail: (id: string | number) => `/Store/Offer/Get/${id}/`,
      create: '/Store/Offer/Add/',
      update: (id: string | number) => `/Store/Offer/Update/${id}/`,
      delete: (id: string | number) => `/Store/Offer/Remove/${id}/`,
      categories: '/Store/Offer/Category/List/',
      types: '/Store/Offer/Types/List/',
      benefitTypes: '/Store/Offer/ListBenefitTypes/',
      platformTypes: '/Store/Offer/ListPlatformType/',
      schemes: {
        list: '/Store/Offer/Schema/List/',
        detail: (id: string | number) => `/Store/Offer/Schema/Get/${id}/`,
        create: '/Store/Offer/Schema/Add/',
        update: (id: string | number) => `/Store/Offer/Schema/Update/${id}/`,
        delete: (id: string | number) => `/Store/Offer/Schema/Remove/${id}/`,
      },
      offerProducts: {
        list: '/Store/Offer/Product/List/',
        add: '/Store/Offer/Product/Add/',
        get: (id: string | number) => `/Store/Offer/Product/Get/${id}/`,
        update: (id: string | number) => `/Store/Offer/Product/Update/${id}/`,
        remove: (id: string | number) => `/Store/Offer/Product/Remove/${id}/`,
      },
    },
    tagsets: {
      list: '/Store/Tagset/List/',
      detail: (id: string | number) => `/Store/Tagset/Get/${id}/`,
      create: '/Store/Tagset/Add/',
      update: (id: string | number) => `/Store/Tagset/Update/${id}/`,
      delete: (id: string | number) => `/Store/Tagset/Remove/${id}/`,
      removeImage: (id: string | number) => `/Store/Tagset/Images/Remove/${id}/`,
    },
    tags: {
      list: '/Store/Tagset/Tags/List/',
      detail: (id: string | number) => `/Store/Tagset/Tags/Get/${id}/`,
      create: '/Store/Tagset/Tags/Add/',
      update: (id: string | number) => `/Store/Tagset/Tags/Update/${id}/`,
      delete: (id: string | number) => `/Store/Tagset/Tags/Remove/${id}/`,
      removeImage: (id: string | number) => `/Store/Tagset/Tags/Images/Remove/${id}/`,
    },
    taggedItems: {
      list: '/Store/TagSet/TaggedItem/List/',
      tagItemList: '/Store/TagItem/List/',
      updateStatus: (id: string | number) => `/Store/TagSet/TaggedItem/UpdateStatus/${id}/`,
      tagProduct: '/Store/TagSet/Tag/Product/Add/',
      tagProductVariant: '/Store/TagSet/Tag/ProductVariant/Add/',
      tagCategory: '/Store/TagSet/Tag/Category/Add',
      tagOffer: '/Store/TagSet/Tag/Offer/Add/',
      tagStore: '/Store/TagSet/Tag/Store/Add/',
    },
    pos: {
      createOrder: '/Store/POS/Order/Create/V2',
      updateOrder: (id: string | number) => `/Store/POS/Order/Update/${id}/`,
      orderTypes: 'Store/Order/GetOrderTypes/',
      devices: {
        list: '/api/pos/admin/devices',
        create: '/api/pos/admin/devices',
        detail: (id: string | number) => `/api/pos/admin/devices/${id}`,
        update: (id: string | number) => `/api/pos/admin/devices/${id}`,
        remove: (id: string | number) => `/api/pos/admin/devices/${id}`,
        status: (id: string | number) => `/api/pos/admin/devices/${id}/status`,
        history: (id: string | number) => `/api/pos/admin/devices/${id}/history`,
        syncHistory: (id: string | number) => `/api/pos/admin/devices/${id}/sync-history`,
      },
    },
    quotations: {
      list: '/Store/Quotation/List/',
      create: '/Store/Quotation/Add/',
      detail: (id: string | number) => `/Store/Quotation/Get/${id}/`,
      update: (id: string | number) => `/Store/Quotation/Update/${id}/`,
      accept: (id: string | number) => `/Store/Quotation/Accept/${id}/`,
      convert: (id: string | number) => `/Store/Quotation/Convert/${id}/`,
      uploadContract: (id: string | number) => `/Store/Quotation/UploadContract/${id}/`,
      removeContract: (id: string | number) => `/Store/Quotation/RemoveContract/${id}/`,
    },
    storeSettings: {
      list: '/Store/StoreSettings/List/',
      create: '/Store/StoreSettings/Add/',
      update: (id: string | number) => `/Store/StoreSettings/Update/${id}/`,
      detail: (id: string | number) => `/Store/StoreSettings/Get/${id}/`,
    },
    branchSettings: {
      list: '/Store/BranchSettings/List/',
      create: '/Store/BranchSettings/Add/',
      update: (id: string | number) => `/Store/BranchSettings/Update/${id}/`,
      detail: (id: string | number) => `/Store/BranchSettings/Get/${id}/`,
    },
    flaticon: {
      search: '/Store/Integrations/Flaticon/Search/',
      download: (id: string | number) => `/Store/Integrations/Flaticon/Download/${id}/`,
    },
    orderTypes: {
      list: '/api/store/order-types/',
      detail: (id: string | number) => `/api/store/order-types/${id}/`,
      byKey: '/api/store/order-types/by-key/',
      systemTypes: '/api/store/order-types/system-types/',
      customTypes: '/api/store/order-types/custom-types/',
      bulkCreate: '/api/store/order-types/bulk-create/',
      activate: (id: string | number) => `/api/store/order-types/${id}/activate/`,
      deactivate: (id: string | number) => `/api/store/order-types/${id}/deactivate/`,
    },
    serveTypes: {
      list: '/api/store/serve-types/',
      detail: (id: string | number) => `/api/store/serve-types/${id}/`,
      byKey: '/api/store/serve-types/by-key/',
      systemTypes: '/api/store/serve-types/system-types/',
      customTypes: '/api/store/serve-types/custom-types/',
      bulkCreate: '/api/store/serve-types/bulk-create/',
      activate: (id: string | number) => `/api/store/serve-types/${id}/activate/`,
      deactivate: (id: string | number) => `/api/store/serve-types/${id}/deactivate/`,
    },
    orderStatusTypes: {
      list: '/api/store/order-status-types/',
      detail: (id: string | number) => `/api/store/order-status-types/${id}/`,
      byValue: '/api/store/order-status-types/by-value/',
      systemStatuses: '/api/store/order-status-types/system-statuses/',
      customStatuses: '/api/store/order-status-types/custom-statuses/',
      activate: (id: string | number) => `/api/store/order-status-types/${id}/activate/`,
      deactivate: (id: string | number) => `/api/store/order-status-types/${id}/deactivate/`,
    },
    orderStatusTransitions: {
      list: '/api/store/order-status-transitions/',
      detail: (id: string | number) => `/api/store/order-status-transitions/${id}/`,
      allowedNext: '/api/store/order-status-transitions/allowed-next/',
    },
    proportionGroups: {
      list: '/Store/Product/ProportionGroup/List/',
      create: '/Store/Product/ProportionGroup/Add/',
      update: (id: string | number) => `/Store/Product/ProportionGroup/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/ProportionGroup/Remove/${id}/`,
    },
    proportions: {
      list: '/Store/Product/Proportion/List/',
      create: '/Store/Product/Proportion/Add/',
      update: (id: string | number) => `/Store/Product/Proportion/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Proportion/Remove/${id}/`,
    },
    variantProportions: {
      list: '/Store/Product/Variant/Proportion/List/',
      create: '/Store/Product/Variant/Proportion/Add/',
      update: (id: string | number) => `/Store/Product/Variant/Proportion/Update/${id}/`,
      delete: (id: string | number) => `/Store/Product/Variant/Proportion/Remove/${id}/`,
    },
    basket: {
      list: '/Store/Basket/List/',
      add: '/Store/Basket/Add/',
      update: (id: string | number) => `/Store/Basket/Update/${encodeURIComponent(String(id))}/`,
      updateItem: (id: string | number) => `/Store/Basket/UpdateItem/${encodeURIComponent(String(id))}/`,
      remove: (id: string | number) => `/Store/Basket/Remove/${encodeURIComponent(String(id))}/`,
    },
  },
  memberships: {
    dashboard: '/Membership/Dashboard/',
    monthlyReport: '/Membership/Report/Monthly/',
    plans: {
      list: '/Membership/Plan/List/',
      create: '/Membership/Plan/Add/',
      detail: (id: string | number) => `/Membership/Plan/Get/${id}/`,
      update: (id: string | number) => `/Membership/Plan/Update/${id}/`,
      delete: (id: string | number) => `/Membership/Plan/Remove/${id}/`,
    },
    packages: {
      list: '/Membership/Package/List/',
      create: '/Membership/Package/Add/',
      detail: (id: string | number) => `/Membership/Package/Get/${id}/`,
      update: (id: string | number) => `/Membership/Package/Update/${id}/`,
      delete: (id: string | number) => `/Membership/Package/Remove/${id}/`,
    },
    subscriptions: {
      list: '/Membership/Subscription/List/',
      create: '/Membership/Subscription/Add/',
      detail: (id: string | number) => `/Membership/Subscription/Get/${id}/`,
      update: (id: string | number) => `/Membership/Subscription/Update/${id}/`,
      delete: (id: string | number) => `/Membership/Subscription/Remove/${id}/`,
      cancel: (id: string | number) => `/Membership/Subscription/Cancel/${id}/`,
      pause: (id: string | number) => `/Membership/Subscription/Pause/${id}/`,
      resume: (id: string | number) => `/Membership/Subscription/Resume/${id}/`,
      extendGrace: (id: string | number) => `/Membership/Subscription/ExtendGrace/${id}/`,
      renewNow: (id: string | number) => `/Membership/Subscription/RenewNow/${id}/`,
      transfer: (id: string | number) => `/Membership/Subscription/Transfer/${id}/`,
    },
    billingPeriods: {
      list: '/Membership/BillingPeriod/List/',
      create: '/Membership/BillingPeriod/Add/',
      detail: (id: string | number) => `/Membership/BillingPeriod/Get/${id}/`,
      update: (id: string | number) => `/Membership/BillingPeriod/Update/${id}/`,
      delete: (id: string | number) => `/Membership/BillingPeriod/Remove/${id}/`,
      requestPayment: (id: string | number) => `/Membership/BillingPeriod/${id}/request_payment/`,
      markPaid: (id: string | number) => `/Membership/BillingPeriod/${id}/mark_paid/`,
      payments: (id: string | number) => `/Membership/BillingPeriod/${id}/payments/`,
      recordPayment: (id: string | number) => `/Membership/BillingPeriod/${id}/record_payment/`,
      removePayment: (id: string | number, paymentId: string | number) => `/Membership/BillingPeriod/${id}/payments/${paymentId}/`,
      paymentReceiptImage: (id: string | number, paymentId: string | number) => `/Membership/BillingPeriod/${id}/payments/${paymentId}/receipt_image/`,
    },
    gatewayMandates: {
      list: '/Membership/GatewayMandate/List/',
      create: '/Membership/GatewayMandate/Add/',
      detail: (id: string | number) => `/Membership/GatewayMandate/Get/${id}/`,
      update: (id: string | number) => `/Membership/GatewayMandate/Update/${id}/`,
      delete: (id: string | number) => `/Membership/GatewayMandate/Remove/${id}/`,
      setupDirectDebit: '/Membership/GatewayMandate/SetupDirectDebit/',
    },
    ageBands: {
      list: '/Membership/AgeBand/List/',
      create: '/Membership/AgeBand/Add/',
      detail: (id: string | number) => `/Membership/AgeBand/Get/${id}/`,
      update: (id: string | number) => `/Membership/AgeBand/Update/${id}/`,
      delete: (id: string | number) => `/Membership/AgeBand/Remove/${id}/`,
    },
    subscriptionMembers: {
      list: '/Membership/SubscriptionMember/List/',
      create: '/Membership/SubscriptionMember/Add/',
      detail: (id: string | number) => `/Membership/SubscriptionMember/Get/${id}/`,
      update: (id: string | number) => `/Membership/SubscriptionMember/Update/${id}/`,
      delete: (id: string | number) => `/Membership/SubscriptionMember/Remove/${id}/`,
      deactivate: (id: string | number) => `/Membership/SubscriptionMember/Deactivate/${id}/`,
    },
    groupMembers: {
      list: '/Membership/GroupMember/List/',
      create: '/Membership/GroupMember/Add/',
      detail: (id: string | number) => `/Membership/GroupMember/Get/${id}/`,
      update: (id: string | number) => `/Membership/GroupMember/Update/${id}/`,
      delete: (id: string | number) => `/Membership/GroupMember/Remove/${id}/`,
      deactivate: (id: string | number) => `/Membership/GroupMember/Deactivate/${id}/`,
    },
    activities: {
      list: '/Membership/Activity/List/',
      create: '/Membership/Activity/Add/',
      detail: (id: string | number) => `/Membership/Activity/Get/${id}/`,
      update: (id: string | number) => `/Membership/Activity/Update/${id}/`,
      delete: (id: string | number) => `/Membership/Activity/Remove/${id}/`,
    },
    paymentBalances: {
      list: '/Membership/PaymentBalance/List/',
      detail: (id: string | number) => `/Membership/PaymentBalance/Get/${id}/`,
      recalculate: '/Membership/PaymentBalance/Recalculate/',
    },
    refunds: {
      list: '/Membership/Refund/List/',
      create: '/Membership/Refund/Add/',
      detail: (id: string | number) => `/Membership/Refund/Get/${id}/`,
      process: (id: string | number) => `/Membership/Refund/Process/${id}/`,
      reject: (id: string | number) => `/Membership/Refund/Reject/${id}/`,
    },
    templates: {
      list: '/Membership/Template/List/',
      create: '/Membership/Template/Add/',
      detail: (id: string | number) => `/Membership/Template/Get/${id}/`,
      update: (id: string | number) => `/Membership/Template/Update/${id}/`,
      delete: (id: string | number) => `/Membership/Template/Remove/${id}/`,
      ensureEmailScenarios: '/Membership/Template/EnsureEmailScenarios/',
    },
    cardTemplates: {
      list: '/Membership/CardTemplate/List/',
      create: '/Membership/CardTemplate/Add/',
      detail: (id: string | number) => `/Membership/CardTemplate/Get/${id}/`,
      update: (id: string | number) => `/Membership/CardTemplate/Update/${id}/`,
      delete: (id: string | number) => `/Membership/CardTemplate/Remove/${id}/`,
      preview: (subscriptionId: string | number) => `/Membership/Card/Preview/${subscriptionId}/`,
      print: (subscriptionId: string | number) => `/Membership/Card/Print/${subscriptionId}/`,
    },
    packageAddOns: {
      list: '/Membership/PackageAddOn/List/',
      create: '/Membership/PackageAddOn/Add/',
      detail: (id: string | number) => `/Membership/PackageAddOn/Get/${id}/`,
      update: (id: string | number) => `/Membership/PackageAddOn/Update/${id}/`,
      delete: (id: string | number) => `/Membership/PackageAddOn/Remove/${id}/`,
    },
    subscriptionAddOns: {
      list: '/Membership/SubscriptionAddOn/List/',
      create: '/Membership/SubscriptionAddOn/Add/',
      detail: (id: string | number) => `/Membership/SubscriptionAddOn/Get/${id}/`,
      update: (id: string | number) => `/Membership/SubscriptionAddOn/Update/${id}/`,
      delete: (id: string | number) => `/Membership/SubscriptionAddOn/Remove/${id}/`,
    },
    verification: {
      scan: '/Membership/Verify/',
    },
    payments: {
      initiate: '/Membership/Payment/Initiate/',
    },
    invoices: {
      create: '/Membership/Invoice/create/',
    },
  },
  jobMedia: {
    list: '/JobMedia/List/',
    upload: '/JobMedia/Upload/',
    delete: (id: string | number) => `/JobMedia/Delete/${id}/`,
  },
  jobManagementConfiguration: {
    current: '/JobManagementConfiguration/Get/',
    update: '/JobManagementConfiguration/Update/',
  },
  jobWorkflow: {
    kinds: {
      list: '/JobKind/List/',
      create: '/JobKind/Add/',
      detail: (id: string | number) => `/JobKind/Get/${id}/`,
      update: (id: string | number) => `/JobKind/Update/${id}/`,
      delete: (id: string | number) => `/JobKind/Delete/${id}/`,
    },
    childRules: {
      list: '/JobKindChildRule/List/',
      create: '/JobKindChildRule/Add/',
      detail: (id: string | number) => `/JobKindChildRule/Get/${id}/`,
      update: (id: string | number) => `/JobKindChildRule/Update/${id}/`,
      delete: (id: string | number) => `/JobKindChildRule/Delete/${id}/`,
    },
    statusDefinitions: {
      list: '/JobWorkflowStatusDefinition/List/',
      create: '/JobWorkflowStatusDefinition/Add/',
      detail: (id: string | number) => `/JobWorkflowStatusDefinition/Get/${id}/`,
      update: (id: string | number) => `/JobWorkflowStatusDefinition/Update/${id}/`,
      delete: (id: string | number) => `/JobWorkflowStatusDefinition/Delete/${id}/`,
    },
    statuses: {
      list: '/JobWorkflowStatus/List/',
      projectList: '/JobWorkflowStatus/Project/List/',
      eventList: '/JobWorkflowStatus/Event/List/',
      create: '/JobWorkflowStatus/Add/',
      detail: (id: string | number) => `/JobWorkflowStatus/Get/${id}/`,
      update: (id: string | number) => `/JobWorkflowStatus/Update/${id}/`,
      delete: (id: string | number) => `/JobWorkflowStatus/Delete/${id}/`,
    },
    transitions: {
      list: '/JobWorkflowTransition/List/',
      projectList: '/JobWorkflowTransition/Project/List/',
      eventList: '/JobWorkflowTransition/Event/List/',
      create: '/JobWorkflowTransition/Add/',
      detail: (id: string | number) => `/JobWorkflowTransition/Get/${id}/`,
      update: (id: string | number) => `/JobWorkflowTransition/Update/${id}/`,
      delete: (id: string | number) => `/JobWorkflowTransition/Delete/${id}/`,
    },
    transitionActors: {
      list: '/JobWorkflowTransitionActor/List/',
      projectList: '/JobWorkflowTransitionActor/Project/List/',
      eventList: '/JobWorkflowTransitionActor/Event/List/',
      create: '/JobWorkflowTransitionActor/Add/',
      detail: (id: string | number) => `/JobWorkflowTransitionActor/Get/${id}/`,
      update: (id: string | number) => `/JobWorkflowTransitionActor/Update/${id}/`,
      delete: (id: string | number) => `/JobWorkflowTransitionActor/Delete/${id}/`,
    },
    cancellationReasons: {
      list: '/JobCancellationReason/List/',
      create: '/JobCancellationReason/Add/',
      detail: (id: string | number) => `/JobCancellationReason/Get/${id}/`,
      update: (id: string | number) => `/JobCancellationReason/Update/${id}/`,
      delete: (id: string | number) => `/JobCancellationReason/Delete/${id}/`,
    },
    stageDefinitions: {
      list: '/JobStageDefinition/List/',
      create: '/JobStageDefinition/Add/',
      detail: (id: string | number) => `/JobStageDefinition/Get/${id}/`,
      update: (id: string | number) => `/JobStageDefinition/Update/${id}/`,
      delete: (id: string | number) => `/JobStageDefinition/Delete/${id}/`,
    },
    stages: {
      list: '/JobStage/List/',
      projectList: '/JobStage/Project/List/',
      eventList: '/JobStage/Event/List/',
      create: '/JobStage/Add/',
      detail: (id: string | number) => `/JobStage/Get/${id}/`,
      update: (id: string | number) => `/JobStage/Update/${id}/`,
      delete: (id: string | number) => `/JobStage/Delete/${id}/`,
    },
    stageTransitions: {
      list: '/JobStageTransition/List/',
      projectList: '/JobStageTransition/Project/List/',
      eventList: '/JobStageTransition/Event/List/',
      create: '/JobStageTransition/Add/',
      detail: (id: string | number) => `/JobStageTransition/Get/${id}/`,
      update: (id: string | number) => `/JobStageTransition/Update/${id}/`,
      delete: (id: string | number) => `/JobStageTransition/Delete/${id}/`,
    },
    stageTransitionActors: {
      list: '/JobStageTransitionActor/List/',
      projectList: '/JobStageTransitionActor/Project/List/',
      eventList: '/JobStageTransitionActor/Event/List/',
      create: '/JobStageTransitionActor/Add/',
      detail: (id: string | number) => `/JobStageTransitionActor/Get/${id}/`,
      update: (id: string | number) => `/JobStageTransitionActor/Update/${id}/`,
      delete: (id: string | number) => `/JobStageTransitionActor/Delete/${id}/`,
    },
    runtime: {
      statusOptions: '/JobWorkflow/StatusOptions/',
      transitions: '/JobWorkflow/Transitions/',
      cancellationReasons: '/JobWorkflow/CancellationReasons/',
      applyStatus: '/JobWorkflow/ApplyStatus/',
      actorOptions: '/JobWorkflow/ActorOptions/',
      stageOptions: '/JobStage/Options/',
      stageTransitions: '/JobStage/Transitions/',
      applyStage: '/JobStage/Apply/',
    },
  },
  orgWorkflow: {
    entityTypes: {
      list: '/Workflow/EntityType/List/',
      create: '/Workflow/EntityType/Add/',
      detail: (id: string | number) => `/Workflow/EntityType/Get/${id}/`,
      update: (id: string | number) => `/Workflow/EntityType/Update/${id}/`,
      delete: (id: string | number) => `/Workflow/EntityType/Remove/${id}/`,
    },
    statusDefinitions: {
      list: '/Workflow/StatusDefinition/List/',
      create: '/Workflow/StatusDefinition/Add/',
      detail: (id: string | number) => `/Workflow/StatusDefinition/Get/${id}/`,
      update: (id: string | number) => `/Workflow/StatusDefinition/Update/${id}/`,
      delete: (id: string | number) => `/Workflow/StatusDefinition/Remove/${id}/`,
    },
    statuses: {
      list: '/Workflow/Status/List/',
      create: '/Workflow/Status/Add/',
      detail: (id: string | number) => `/Workflow/Status/Get/${id}/`,
      update: (id: string | number) => `/Workflow/Status/Update/${id}/`,
      delete: (id: string | number) => `/Workflow/Status/Remove/${id}/`,
    },
    transitions: {
      list: '/Workflow/Transition/List/',
      create: '/Workflow/Transition/Add/',
      detail: (id: string | number) => `/Workflow/Transition/Get/${id}/`,
      update: (id: string | number) => `/Workflow/Transition/Update/${id}/`,
      delete: (id: string | number) => `/Workflow/Transition/Remove/${id}/`,
    },
    transitionActors: {
      list: '/Workflow/TransitionActor/List/',
      create: '/Workflow/TransitionActor/Add/',
      detail: (id: string | number) => `/Workflow/TransitionActor/Get/${id}/`,
      update: (id: string | number) => `/Workflow/TransitionActor/Update/${id}/`,
      delete: (id: string | number) => `/Workflow/TransitionActor/Remove/${id}/`,
    },
  },
  categories: {
    list: '/JobCategory/List/',
    projectList: '/JobCategory/Project/List/',
    eventList: '/JobCategory/Event/List/',
    committeeList: '/JobCategory/Committee/List/',
    create: '/JobCategory/Add/',
    projectCreate: '/JobCategory/Project/Add/',
    eventCreate: '/JobCategory/Event/Add/',
    committeeCreate: '/JobCategory/Committee/Add/',
    detail: (id: string) => `/JobCategory/Get/${id}/`,
    projectDetail: (id: string) => `/JobCategory/Project/Get/${id}/`,
    eventDetail: (id: string) => `/JobCategory/Event/Get/${id}/`,
    committeeDetail: (id: string) => `/JobCategory/Committee/Get/${id}/`,
    update: (id: string) => `/JobCategory/Update/${id}/`,
    projectUpdate: (id: string) => `/JobCategory/Project/Update/${id}/`,
    eventUpdate: (id: string) => `/JobCategory/Event/Update/${id}/`,
    committeeUpdate: (id: string) => `/JobCategory/Committee/Update/${id}/`,
    deactivate: (id: string) => `/JobCategory/Deactivate/${id}/`,
    projectDeactivate: (id: string) => `/JobCategory/Project/Deactivate/${id}/`,
    eventDeactivate: (id: string) => `/JobCategory/Event/Deactivate/${id}/`,
    committeeDeactivate: (id: string) => `/JobCategory/Committee/Deactivate/${id}/`,
    activate: (id: string) => `/JobCategory/Activate/${id}/`,
    projectActivate: (id: string) => `/JobCategory/Project/Activate/${id}/`,
    eventActivate: (id: string) => `/JobCategory/Event/Activate/${id}/`,
    committeeActivate: (id: string) => `/JobCategory/Committee/Activate/${id}/`,
    delete: (id: string) => `/JobCategory/Delete/${id}/`,
    projectDelete: (id: string) => `/JobCategory/Project/Delete/${id}/`,
    eventDelete: (id: string) => `/JobCategory/Event/Delete/${id}/`,
    committeeDelete: (id: string) => `/JobCategory/Committee/Delete/${id}/`,
  },
  locations: {
    list: '/Location/List/',
    create: '/Location/Add/',
    detail: (id: string) => `/Location/Get/${id}/`,
    update: (id: string) => `/Location/Update/${id}/`,
    delete: (id: string) => `/Location/Delete/${id}/`,
  },
  assignments: {
    list: '/JobAssignment/List/',
    listProject: '/JobAssignment/Project/List/',
    listEvent: '/JobAssignment/Event/List/',
    create: '/JobAssignment/Add/',
    detail: (id: string) => `/JobAssignment/Get/${id}/`,
    jobView: (id: string) => `/JobAssignment/Details/${id}/`,
    update: (id: string) => `/JobAssignment/Update/${id}/`,
    generateWorkerInvoice: (id: string) => `/JobAssignment/GenerateWorkerInvoice/${id}/`,
    delete: (id: string) => `/JobAssignment/Delete/${id}/`,
  },
  audits: {
    list: '/JobAudit/List/',
    actions: '/JobAudit/Actions/',
    detail: (id: string) => `/JobAudit/Get/${id}/`,
  },
  workDays: {
    list: '/JobWorkDay/List/',
    listProject: '/JobWorkDay/Project/List/',
    listEvent: '/JobWorkDay/Event/List/',
    create: '/JobWorkDay/Add/',
    detail: (id: string) => `/JobWorkDay/Get/${id}/`,
    update: (id: string) => `/JobWorkDay/Update/${id}/`,
    syncAssignmentEntries: (id: string) => `/JobWorkDay/SyncAssignmentEntries/${id}/`,
    delete: (id: string) => `/JobWorkDay/Delete/${id}/`,
  },
  shiftTemplates: {
    list: '/ShiftTemplate/List/',
    create: '/ShiftTemplate/Add/',
  },
  workDayEntries: {
    list: '/JobWorkDayEntry/List/',
    listProject: '/JobWorkDayEntry/Project/List/',
    listEvent: '/JobWorkDayEntry/Event/List/',
    create: '/JobWorkDayEntry/Add/',
    detail: (id: string) => `/JobWorkDayEntry/Get/${id}/`,
    update: (id: string) => `/JobWorkDayEntry/Update/${id}/`,
    setStatus: (id: string) => `/JobWorkDayEntry/SetStatus/${id}/`,
    clearAttention: (id: string) => `/JobWorkDayEntry/ClearAttention/${id}/`,
    delete: (id: string) => `/JobWorkDayEntry/Delete/${id}/`,
  },
  workers: {
    list: '/Worker/List/',
    create: '/Worker/Admin/Add/',
    import: '/Worker/Import/',
    detail: (id: string) => `/Worker/Get/${id}/`,
    update: (id: string) => `/Worker/Update/${id}/`,
    delete: (id: string) => `/Worker/Delete/${id}/`,
    creationPosts: '/Worker/CreationPosts/List/',
    myProfiles: '/Job/Worker/MyProfiles/',
    pendingApprovals: '/Worker/List/',
    approve: (id: string) => `/Worker/Update/${id}/`,
    reject: (id: string) => `/Worker/Update/${id}/`,
    availability: (_workerId: string) => '/workers/available/',
    availabilityWeek: '/workers/availability/',
    locationSearch: (id: string | number) => `/Job/Worker/Location/Search/${id}/`,
    documents: (_workerId: string) => '/Job/Worker/Document/List/',
    documentCreate: '/Job/Worker/Document/Add/',
    documentDetail: (_workerId: string, documentId: string) => `/Job/Worker/Document/Get/${documentId}/`,
    documentUpdate: (documentId: string) => `/Job/Worker/Document/Update/${documentId}/`,
    documentDelete: (documentId: string) => `/Job/Worker/Document/Delete/${documentId}/`,
    documentSections: '/Job/Worker/DocumentSection/List/',
    documentSectionCreate: '/Job/Worker/DocumentSection/Add/',
    documentSectionDetail: (sectionId: string) => `/Job/Worker/DocumentSection/Get/${sectionId}/`,
    documentSectionUpdate: (sectionId: string) => `/Job/Worker/DocumentSection/Update/${sectionId}/`,
    documentSectionDelete: (sectionId: string) => `/Job/Worker/DocumentSection/Delete/${sectionId}/`,
    vehicles: (_workerId: string) => '/Job/Worker/Vehicle/List/',
    vehiclesCreate: '/Job/Worker/Vehicle/Add/',
    vehiclesDescription: '/Job/Worker/Vehicle/Description/',
    vehicleMakes: '/Job/Worker/Vehicle/Make/List/',
    vehicleMakeCreate: '/Job/Worker/Vehicle/Make/Add/',
    vehicleMakeUpdate: (makeId: string) => `/Job/Worker/Vehicle/Make/Update/${makeId}/`,
    vehicleMakeDelete: (makeId: string) => `/Job/Worker/Vehicle/Make/Remove/${makeId}/`,
    vehicleModels: '/Job/Worker/Vehicle/Model/List/',
    vehicleModelCreate: '/Job/Worker/Vehicle/Model/Add/',
    vehicleModelUpdate: (modelId: string) => `/Job/Worker/Vehicle/Model/Update/${modelId}/`,
    vehicleModelDelete: (modelId: string) => `/Job/Worker/Vehicle/Model/Remove/${modelId}/`,
    vehicleTypes: '/Job/Worker/Vehicle/Type/List/',
    vehicleTypeCreate: '/Job/Worker/Vehicle/Type/Add/',
    vehicleTypeUpdate: (typeId: string) => `/Job/Worker/Vehicle/Type/Update/${typeId}/`,
    vehicleTypeDelete: (typeId: string) => `/Job/Worker/Vehicle/Type/Remove/${typeId}/`,
    vehicleUsages: '/Job/Worker/Vehicle/Usage/List/',
    vehicleUsageCreate: '/Job/Worker/Vehicle/Usage/Add/',
    vehicleUsageUpdate: (usageId: string) => `/Job/Worker/Vehicle/Usage/Update/${usageId}/`,
    vehicleUsageDelete: (usageId: string) => `/Job/Worker/Vehicle/Usage/Remove/${usageId}/`,
    // Backward-compatible aliases
    vehicleHolders: '/Job/Worker/Vehicle/Holder/List/',
    vehicleHolderCreate: '/Job/Worker/Vehicle/Holder/Add/',
    vehicleHolderUpdate: (holderId: string) => `/Job/Worker/Vehicle/Holder/Update/${holderId}/`,
    vehicleHolderDelete: (holderId: string) => `/Job/Worker/Vehicle/Holder/Remove/${holderId}/`,
    vehicleUpdate: (vehicleId: string) => `/Job/Worker/Vehicle/Update/${vehicleId}/`,
    vehicleDetail: (_workerId: string, vehicleId: string) => `/Job/Worker/Vehicle/Remove/${vehicleId}/`,
    vehicleDelete: (vehicleId: string) => `/Job/Worker/Vehicle/Remove/${vehicleId}/`,
    attendance: '/Job/Worker/Attendance/List/',
    attendanceCreate: '/Job/Worker/Attendance/Add/',
    attendanceList: (_workerId: string) => '/Job/Worker/Attendance/List/',
    attendanceDelete: (attendanceId: string | number) => `/Job/Worker/Attendance/Delete/${attendanceId}/`,
    attendanceBoardLocations: '/Job/Attendance/Board/Locations/',
    attendanceBoardDay: '/Job/Attendance/Board/Day/',
    attendanceBoardRoster: '/Job/Attendance/Board/Roster/',
    leaveTypes: '/Job/Worker/LeaveTypes/List/',
    holidays: '/Job/Worker/Holidays/List/',
    leaveRequests: '/Job/Worker/LeaveRequests/',
    leaveRequestCancel: (id: string | number) => `/Job/Worker/LeaveRequests/${id}/Cancel/`,
    adminLeaveTypes: '/Job/Admin/LeaveTypes/',
    adminLeaveTypeDetail: (id: string | number) => `/Job/Admin/LeaveTypes/${id}/`,
    adminHolidays: '/Job/Admin/Holidays/',
    adminHolidayDetail: (id: string | number) => `/Job/Admin/Holidays/${id}/`,
    adminLeaveRequests: '/Job/Admin/LeaveRequests/',
    adminLeaveRequestApprove: (id: string | number) => `/Job/Admin/LeaveRequests/${id}/Approve/`,
    adminLeaveRequestReject: (id: string | number) => `/Job/Admin/LeaveRequests/${id}/Reject/`,
    adminAttendanceRequests: '/Job/Admin/AttendanceRequests/',
    adminAttendanceRequestApprove: (id: string | number) => `/Job/Admin/AttendanceRequests/${id}/Approve/`,
    adminAttendanceRequestReject: (id: string | number) => `/Job/Admin/AttendanceRequests/${id}/Reject/`,
    admsDeviceRegister: '/Job/Attendance/ADMS/Device/Register/',
    admsDeviceUpdate: '/Job/Attendance/ADMS/Device/Update/',
    admsDeviceList: '/Job/Attendance/ADMS/Device/List/',
    admsMappingUpsert: '/Job/Attendance/ADMS/Mapping/Upsert/',
    admsMappingList: '/Job/Attendance/ADMS/Mapping/List/',
    workerSkillsList: '/WorkerSkill/List/',
    workerSkillsCreate: '/WorkerSkill/Add/',
    workerSkillsGet: (id: string | number) => `/WorkerSkill/Get/${id}/`,
    workerSkillsUpdate: (id: string | number) => `/WorkerSkill/Update/${id}/`,
    workerSkillsDelete: (id: string | number) => `/WorkerSkill/Delete/${id}/`,
    workerPayScalesList: '/WorkerPayScale/List/',
    workerPayScalesCreate: '/WorkerPayScale/Add/',
    workerPayScalesGet: (id: string | number) => `/WorkerPayScale/Get/${id}/`,
    workerPayScalesUpdate: (id: string | number) => `/WorkerPayScale/Update/${id}/`,
    workerPayScalesDelete: (id: string | number) => `/WorkerPayScale/Delete/${id}/`,
    hotlineList: '/Worker/Hotline/List/',
    hotlineAdd: '/Worker/Hotline/Add/',
    hotlineUpdate: (id: string | number) => `/Worker/Hotline/Update/${id}/`,
    hotlineExit: '/Worker/Hotline/Exit/',
    crewTemplatesList: '/CrewTemplate/List/',
    crewTemplatesCreate: '/CrewTemplate/Add/',
    crewTemplatesGet: (id: string | number) => `/CrewTemplate/Get/${id}/`,
    crewTemplatesUpdate: (id: string | number) => `/CrewTemplate/Update/${id}/`,
    crewTemplatesDelete: (id: string | number) => `/CrewTemplate/Delete/${id}/`,
    crewTemplateSlotsList: '/CrewTemplateSlot/List/',
    crewTemplateSlotsCreate: '/CrewTemplateSlot/Add/',
    crewTemplateSlotsUpdate: (id: string | number) => `/CrewTemplateSlot/Update/${id}/`,
    crewTemplateSlotsDelete: (id: string | number) => `/CrewTemplateSlot/Delete/${id}/`,
    crewsList: '/Crew/List/',
    crewsReadyList: '/Crew/Ready/List/',
    crewsCreate: '/Crew/Add/',
    crewsGet: (id: string | number) => `/Crew/Get/${id}/`,
    crewsUpdate: (id: string | number) => `/Crew/Update/${id}/`,
    crewsDelete: (id: string | number) => `/Crew/Delete/${id}/`,
    crewsAssignToJob: '/Crew/Assign/ToJob/',
    crewMembersList: '/CrewMember/List/',
    crewMembersCreate: '/CrewMember/Add/',
    crewMembersUpdate: (id: string | number) => `/CrewMember/Update/${id}/`,
    crewMembersDelete: (id: string | number) => `/CrewMember/Delete/${id}/`,
    idCardReset: (id: string | number) => `/Worker/IdCard/Reset/${id}/`,
    idCardResolve: '/Worker/IdCard/Resolve/',
  },
  payTypes: {
    list: '/PayType/List/',
  },
  finance: {
    expenses: '/Job/Expenses/',
    createExpense: '/Job/Expenses/',
    expenseDetail: (id: string) => `/Job/Expenses/${id}/`,
    updateExpense: (id: string) => `/Job/Expenses/${id}/`,
    deleteExpense: (id: string) => `/Job/Expenses/${id}/`,
    incomes: '/Job/Incomes/',
    createIncome: '/Job/Incomes/',
    incomeDetail: (id: string) => `/Job/Incomes/${id}/`,
    updateIncome: (id: string) => `/Job/Incomes/${id}/`,
    deleteIncome: (id: string) => `/Job/Incomes/${id}/`,
    setExpenseStatus: (id: string) => `/JobExpense/SetStatus/${id}/`,
    expenseStatusTimeline: (id: string) => `/JobExpense/StatusTimeline/${id}/`,
    uploadExpenseReceipt: (id: string) => `/JobExpenseReceipt/Upload/${id}/`,
    deleteExpenseReceipt: (id: string) => `/JobExpenseReceipt/Delete/${id}/`,
    expenseCategories: '/JobExpenseCategory/List/',
    createExpenseCategory: '/JobExpenseCategory/Add/',
    updateExpenseCategory: (id: string) => `/JobExpenseCategory/Update/${id}/`,
    deleteExpenseCategory: (id: string) => `/JobExpenseCategory/Delete/${id}/`,
    expensePayments: '/JobExpensePayment/List/',
    createExpensePayment: '/JobExpensePayment/Add/',
    updateExpensePayment: (id: string) => `/JobExpensePayment/Update/${id}/`,
    deleteExpensePayment: (id: string) => `/JobExpensePayment/Delete/${id}/`,
    particulars: '/Job/Particulars/',
    createParticular: '/Job/Particulars/',
    particularDetail: (id: string) => `/Job/Particulars/${id}/`,
    updateParticular: (id: string) => `/Job/Particulars/${id}/`,
    deleteParticular: (id: string) => `/Job/Particulars/${id}/`,
    markParticularRequested: (id: string) => `/JobParticular/MarkRequested/${id}/`,
    markParticularOrderPlaced: (id: string) => `/JobParticular/MarkOrderPlaced/${id}/`,
    markParticularArrived: (id: string) => `/JobParticular/MarkArrived/${id}/`,
    approveParticularPurchase: (id: string) => `/JobParticular/Approve/${id}/`,
    rejectParticularPurchase: (id: string) => `/JobParticular/Reject/${id}/`,
    setParticularInStock: (id: string) => `/JobParticular/SetInStock/${id}/`,
    particularStatusTimeline: (id: string) => `/JobParticular/StatusTimeline/${id}/`,
    invoicePreview: (jobId: string) => `/Job/InvoicePreview/${jobId}/`,
    invoices: '/JobInvoice/List/',
    createInvoice: '/JobInvoice/Add/',
    invoiceDetail: (id: string) => `/JobInvoice/Get/${id}/`,
    updateInvoice: (id: string) => `/JobInvoice/Update/${id}/`,
    deleteInvoice: (id: string) => `/JobInvoice/Delete/${id}/`,
    issueInvoice: (id: string) => `/JobInvoice/Issue/${id}/`,
    resendInvoice: (id: string) => `/JobInvoice/Resend/${id}/`,
    markInvoicePaid: (id: string) => `/JobInvoice/MarkPaid/${id}/`,
    voidInvoice: (id: string) => `/JobInvoice/Void/${id}/`,
    invoicePayments: '/JobInvoicePayment/List/',
    createInvoicePayment: '/JobInvoicePayment/Add/',
    invoicePaymentDetail: (id: string) => `/JobInvoicePayment/Get/${id}/`,
    updateInvoicePayment: (id: string) => `/JobInvoicePayment/Update/${id}/`,
    deleteInvoicePayment: (id: string) => `/JobInvoicePayment/Delete/${id}/`,
    jobPayments: '/JobPayments/List/',
    createJobPayment: '/JobPayments/Add/',
    jobPaymentDetail: (id: string) => `/JobPayments/Get/${id}/`,
    updateJobPayment: (id: string) => `/JobPayments/Update/${id}/`,
    deleteJobPayment: (id: string) => `/JobPayments/Delete/${id}/`,
    publicInvoicePaymentDetail: (jobId: string | number, invoiceId: string | number) => `/JobInvoicePayment/Public/${jobId}/${invoiceId}/`,
    initiateInvoicePayment: (jobId: string | number, invoiceId: string | number) => `/JobInvoicePayment/Public/${jobId}/${invoiceId}/Initiate/`,
    confirmInvoiceStripePayment: (jobId: string | number, invoiceId: string | number) => `/JobInvoicePayment/Public/${jobId}/${invoiceId}/Confirm/`,
    publicInvoicePaymentTokenDetail: (token: string) => `/JobInvoicePayment/Public/${encodeURIComponent(token)}/`,
    initiateInvoiceTokenPayment: (token: string) => `/JobInvoicePayment/Public/${encodeURIComponent(token)}/Initiate/`,
    confirmInvoiceTokenStripePayment: (token: string) => `/JobInvoicePayment/Public/${encodeURIComponent(token)}/Confirm/`,
    publicInvoicePaymentTokenStatus: (token: string) => `/JobInvoicePayment/Public/${encodeURIComponent(token)}/Status/`,
    workerPaymentsSummary: '/worker-payments/summary/',
    workerPaymentPeriods: '/worker-payments/periods/',
    workerInvoiceGenerationRuns: '/worker-payments/generation-runs/',
    workerDraftInvoice: '/Job/Worker/Invoice/Draft/',
    recordWorkerPayment: '/worker-payments/record/',
    updateWorkerPayment: (id: string | number) => `/worker-payments/update/${id}/`,
    deactivateWorkerPayment: (id: string | number) => `/worker-payments/deactivate/${id}/`,
    deactivateWorkerPaymentInvoice: (id: string | number) => `/worker-payments/deactivate-invoice/${id}/`,
    resendWorkerPaymentInvoice: (id: string | number) => `/worker-payments/resend-invoice/${id}/`,
    generateWorkerDailyInvoices: '/worker-payments/generate-daily/',
    workerDailyInvoiceList: '/worker-payments/daily/',
    workerDailyInvoiceDetail: (id: string | number) => `/worker-payments/daily/${id}/`,
    companyPaymentsSummary: '/company-payments/summary/',
    companyPaymentJobs: '/company-payments/jobs/',
    recordCompanyPayment: '/company-payments/record/',
    settlementInvoicesList: '/Job/Settlement/Invoices/List/',
    settlementInvoicesGenerate: '/Job/Settlement/Invoices/Generate/',
    recordSettlementPayment: '/Job/Settlement/Payment/Record/',
    jobPaymentSummary: (jobId: string | number) => `/Job/PaymentSummary/${jobId}/`,
    orderPaymentSummary: (orderId: string | number) => `/Job/Order/PaymentSummary/${orderId}/`,
    notificationEventsList: '/Job/Notification/Events/List/',
    notificationContactsList: '/Job/Notification/Contacts/List/',
    notificationContactsAdd: '/Job/Notification/Contacts/Add/',
    notificationContactUpdate: (id: string | number) => `/Job/Notification/Contacts/Update/${id}/`,
    notificationContactRemove: (id: string | number) => `/Job/Notification/Contacts/Remove/${id}/`,
    notificationDeliveryLogsList: '/Job/Notification/DeliveryLogs/List/',
  },
  reports: {
    monthwise: '/reports/monthly/jobs/',
    orderMonthwise: '/reports/monthly/orders/',
    worker: '/reports/monthly/workers/',
    client: '/reports/client/',
    clientInvoices: '/reports/client/invoices/',
    company: '/reports/company/',
  },
  account: {
    profile: '/account/profile/',
    contactInfo: '/account/contact-info/',
    avatarUpload: '/Org/User/ProfileImg/Add/',
    avatarDelete: (id: string | number) => `/Org/User/ProfileImg/Delete/${id}/`,
    addresses: '/account/addresses/',
    addressDetail: (id: string) => `/account/addresses/${id}/`,
    setDefaultAddress: (id: string) => `/account/addresses/${id}/set-default/`,
    changePassword: '/account/password/change/',
  },
  profileAddress: {
    list: '/Org/User/Address/List/',
    create: '/Org/User/Address/Add/',
    update: (id: string | number) => `/Org/User/Address/Update/${id}/`,
    delete: (id: string | number) => `/Org/User/Address/Delete/${id}/`,
    setDefault: (id: string | number) => `/Org/User/Address/SetDefaultAddress/${id}/`,
  },
  dashboard: {
    summary: '/Job/Dashboard/',
    realtime: '/Job/Realtime/',
    scheduleWorkers: '/Job/ScheduleWorkers/',
  },
  events: {
    workday: {
      ensureEntries: (jobId: string | number) => `/events/by-job/${jobId}/workday/ensure-entries/`,
      syncWorkers: (jobId: string | number) => `/events/by-job/${jobId}/workday/sync-workers/`,
      checkinStatus: (jobId: string | number) => `/events/by-job/${jobId}/workday/checkin-status/`,
      checkin: (jobId: string | number) => `/events/by-job/${jobId}/workday/checkin/`,
      checkout: (jobId: string | number) => `/events/by-job/${jobId}/workday/checkout/`,
    },
    payment: {
      snapshot: (jobId: string | number) => `/events/by-job/${jobId}/payment/snapshot/`,
      workerStatus: (jobId: string | number) => `/events/by-job/${jobId}/payment/worker-status/`,
      generateInvoices: (jobId: string | number) => `/events/by-job/${jobId}/payment/generate-invoices/`,
      processWorker: (jobId: string | number) => `/events/by-job/${jobId}/payment/process-worker/`,
      reconcile: (jobId: string | number) => `/events/by-job/${jobId}/payment/reconcile/`,
    },
    invoices: {
      list: (jobId: string | number) => `/events/by-job/${jobId}/invoices/`,
      unpaid: (jobId: string | number) => `/events/by-job/${jobId}/invoices/unpaid/`,
      summary: (jobId: string | number) => `/events/by-job/${jobId}/invoices/summary/`,
      finalize: (jobId: string | number, invoiceId: string | number) => `/events/by-job/${jobId}/invoices/${invoiceId}/finalize/`,
      markPaid: (jobId: string | number, invoiceId: string | number) => `/events/by-job/${jobId}/invoices/${invoiceId}/mark-paid/`,
    },
    workflow: {
      currentStatus: (jobId: string | number) => `/events/by-job/${jobId}/workflow/status/`,
      applyStatus: (jobId: string | number) => `/events/by-job/${jobId}/workflow/apply-status/`,
    },
  },
  sales: {
    enquiries: {
      list: '/api/contact/enquiry/list/',
      markRead: (id: number) => `/api/contact/enquiry/${id}/read/`,
      staffCreate: '/api/contact/enquiry/staff/add/',
      createCustomer: (id: number) => `/api/contact/enquiry/${id}/create-customer/`,
      updateStage: (id: number) => `/api/contact/enquiry/${id}/stage/`,
    },
    followups: {
      list: '/api/sales/followup/list/',
      create: '/api/sales/followup/add/',
      update: (id: number) => `/api/sales/followup/${id}/update/`,
      complete: (id: number) => `/api/sales/followup/${id}/complete/`,
      delete: (id: number) => `/api/sales/followup/${id}/delete/`,
    },
  },
  assets: {
    list: '/Asset/List/',
    create: '/Asset/Add/',
    detail: (id: string | number) => `/Asset/Get/${id}/`,
    update: (id: string | number) => `/Asset/Update/${id}/`,
    delete: (id: string | number) => `/Asset/Delete/${id}/`,
    byCode: '/Asset/ByCode/',
    history: (id: string | number) => `/Asset/${id}/History/`,
    createWorkOrder: (id: string | number) => `/Asset/${id}/WorkOrder/Add/`,
    categories: '/Asset/Category/List/',
    categoryCreate: '/Asset/Category/Add/',
    locations: '/Asset/Location/List/',
    locationCreate: '/Asset/Location/Add/',
    plans: '/Asset/MaintenancePlan/List/',
    planCreate: '/Asset/MaintenancePlan/Add/',
    planUpdate: (id: string | number) => `/Asset/MaintenancePlan/Update/${id}/`,
    planDelete: (id: string | number) => `/Asset/MaintenancePlan/Delete/${id}/`,
    planGenerateNext: (id: string | number) => `/Asset/MaintenancePlan/${id}/GenerateNext/`,
    maintenanceOverdue: '/Asset/Maintenance/Overdue/',
    maintenanceUpcoming: '/Asset/Maintenance/Upcoming/',
    jobAssets: '/Asset/Job/List/',
    jobAssetsLink: '/Asset/Job/Link/',
    orderItemAssets: '/Asset/OrderItem/List/',
    orderItemAssetsLink: '/Asset/OrderItem/Link/',
    meters: '/Asset/Meter/List/',
    meterCreate: '/Asset/Meter/Add/',
    meterReading: (id: string | number) => `/Asset/Meter/${id}/Reading/Add/`,
    documents: '/Asset/Document/List/',
    documentCreate: '/Asset/Document/Add/',
    configurationGet: '/Asset/Configuration/Get/',
    configurationUpdate: '/Asset/Configuration/Update/',
    customerAssets: (userId: string | number) => `/Asset/Customer/${userId}/List/`,
    reliabilityReport: '/Asset/Reports/Reliability/',
    vehicleSync: '/Asset/Vehicle/Sync/',
    planApplyTemplate: '/Asset/MaintenancePlan/ApplyTemplate/',
    contracts: '/Asset/Contract/List/',
    contractCreate: '/Asset/Contract/Add/',
    contractUpdate: (id: string | number) => `/Asset/Contract/Update/${id}/`,
    contractDelete: (id: string | number) => `/Asset/Contract/Delete/${id}/`,
    contractSetAssets: (id: string | number) => `/Asset/Contract/${id}/SetAssets/`,
    bom: '/Asset/Bom/List/',
    bomCreate: '/Asset/Bom/Add/',
    bomDelete: (id: string | number) => `/Asset/Bom/Delete/${id}/`,
    transfers: '/Asset/Transfer/List/',
    transferCreate: '/Asset/Transfer/Add/',
    transferComplete: (id: string | number) => `/Asset/Transfer/${id}/Complete/`,
    transferCancel: (id: string | number) => `/Asset/Transfer/${id}/Cancel/`,
    iotSources: '/Asset/IoT/List/',
    iotRegister: '/Asset/IoT/Register/',
    iotDelete: (id: string | number) => `/Asset/IoT/Delete/${id}/`,
    iotIngest: '/Asset/IoT/Ingest/',
    inspections: '/Asset/Inspection/List/',
    inspectionCreate: '/Asset/Inspection/Add/',
    finance: (id: string | number) => `/Asset/${id}/Finance/`,
    export: '/Asset/Export/',
    import: '/Asset/Import/',
    bulkGenerate: '/Asset/Maintenance/BulkGenerate/',
    maintenanceInProgress: '/Asset/Maintenance/InProgress/',
    children: (id: string | number) => `/Asset/${id}/Children/`,
    setParent: (id: string | number) => `/Asset/${id}/SetParent/`,
    myAssets: '/Asset/Customer/Me/List/',
    reminders: '/Asset/Reminder/List/',
    reminderScan: '/Asset/Reminder/Scan/',
    reminderDispatch: '/Asset/Reminder/Dispatch/',
    reminderAcknowledge: (id: string | number) => `/Asset/Reminder/${id}/Acknowledge/`,
  },
} as const
